export default [
  { source: 'Oscar Wilde', text: 'Be yourself; everyone else is already taken.' },
  { source: 'Oscar Wilde', text: 'Always forgive your enemies; nothing annoys them so much.' },
  {
    source: 'Virginia Satir',
    text: 'We must not allow other people’s limited perceptions to define us.'
  },
  { source: 'William Shakespeare', text: 'This above all: to thine own self be true.' },
  {
    source: 'Helen Keller',
    text: 'Walking with a friend in the dark is better than walking alone in the light.'
  },
  {
    source: 'Winston Churchill',
    text:
      'Courage is what it takes to stand up and speak. Courage is also what it takes to sit down and listen.'
  },
  {
    source: 'Martin Luther King, Jr.',
    text: 'Forgiveness is not an occasional act; it is a constant attitude.'
  },
  { source: 'J.R.R. Tolkien', text: 'Courage is found in unlikely places.' },
  { source: 'J.R.R. Tolkien', text: "Where there's life there's hope." },
  {
    source: 'J.R.R. Tolkien',
    text: 'It is not the strength of the body that counts, but the strength of the spirit.'
  },
  {
    source: 'Dr. Seuss',
    text:
      'Be who you are and say what you feel, because those who mind don’t matter and those who matter don’t mind.'
  },
  {
    source: 'Stephen King',
    text:
      "You can't deny laughter; when it comes, it plops down in your favorite chair and stays as long as it wants."
  },
  { source: 'Abraham Lincoln', text: 'No man has a good enough memory to be a successful liar.' },
  { source: 'Mark Twain', text: 'All generalizations are false, including this one.' },
  { source: 'Ronald Reagan', text: 'One picture is worth 1,000 denials.' },
  {
    source: 'Eleanor Roosevelt',
    text: 'Great minds discuss ideas; average minds discuss events; small minds discuss people.'
  },
  {
    source: 'J.K. Rowling',
    text: 'It is our choices, that show what we truly are, far more than our abilities.'
  },
  {
    source: 'Dax Shephard',
    text:
      'Success is just a war of attrition. Sure, there’s an element of talent you should probably possess. But if you just stick around long enough, eventually something is going to happen.'
  },
  {
    source: 'Katherine Hepburn',
    text: 'If you always do what interests you, at least one person is pleased.'
  },
  {
    source: 'Audrey Hepburn',
    text: "Nothing is impossible, the word itself says 'I'm possible'!"
  },
  {
    source: 'Wilma Rudolph',
    text:
      'It is Never underestimate the power of dreams and the influence of the human spirit. We are all the same in this notion: The potential for greatness lives within each of us.” choices, that show what we truly are, far more than our abilities.'
  },
  {
    source: 'Francois de La Rochefoucauld',
    text: 'To achieve greatness one should live as if they will never die.'
  },
  {
    source: 'Edmund Hillary',
    text:
      'People do not decide to become extraordinary. They decide to accomplish extraordinary things.'
  },
  {
    source: 'Albert Einstein',
    text: 'A person who never made a mistake never tried anything new.'
  },
  {
    source: 'Jimmy Dean',
    text:
      'I can’t change the direction of the wind, but I can adjust my sails to always reach my destination.'
  },
  {
    source: 'Nelson Mandela',
    text: 'A winner is a dreamer who never gives up.'
  },
  {
    source: 'Eleanor Roosevelt',
    text: 'No one can make you feel inferior without your consent.'
  },
  {
    source: 'Henry Ford',
    text: 'Whether you think you can or you think you can’t, you’re right.'
  },
  {
    source: 'Alice Walker',
    text: 'The most common way people give up their power is by thinking they don’t have any.'
  },
  {
    source: 'Oprah Winfrey',
    text:
      'Be thankful for what you have; you’ll end up having more. If you concentrate on what you don’t have, you will never, ever have enough.'
  },
  {
    source: 'Hellen Keller',
    text:
      'When one door of happiness closes, another opens, but often we look so long at the closed door that we do not see the one that has been opened for us.'
  },
  {
    source: 'George Addair',
    text: 'Everything you’ve ever wanted is on the other side of fear.'
  },
  {
    source: 'Amelia Earhart',
    text: 'The most difficult thing is the decision to act, the rest is merely tenacity.'
  },
  {
    source: 'George Whitefield',
    text:
      'Press forward. Do not stop, do not linger in your journey, but strive for the mark set before you.'
  },
  {
    source: 'Charles Swindoll',
    text: 'Life is 10% what happens to me and 90% of how I react to it.'
  },
  {
    source: 'Michael Phelps',
    text:
      'There will be obstacles. There will be doubters. There will be mistakes. But with hard work, there are no limits.'
  },
  {
    source: 'Babe Ruth',
    text: 'You just can’t beat the person who never gives up.'
  },
  {
    source: 'Thomas Edison',
    text:
      'Many of life’s failures are people who did not realize how close they were to success when they gave up.'
  },
  {
    source: 'Aristotle Onassis',
    text: 'It is during our darkest moments that we must focus to see the light.'
  },
  {
    source: 'Eleanor Roosevelt',
    text: 'With the new day comes new strength and new thoughts.'
  },
  {
    source: 'Robert Louis Stevenson',
    text: 'Don’t judge each day by the harvest you reap but by the seeds that you plant.'
  },
  {
    source: 'Vincent Van Gogh',
    text:
      'If you hear a voice within you say ‘you cannot paint,’ then by all means paint and that voice will be silenced.'
  },
  {
    source: 'Roy T. Bennett',
    text: 'Don’t be pushed around by the fears in your mind. Be led by the dreams in your heart.'
  },
  {
    source: 'Mark Cuban',
    text: 'It is our choices, that show what we truly are, far more than our abilities.'
  },
  {
    source: 'Maya Angelou',
    text: 'If you don’t like something, change it.  If you can’t change it, change your attitude.'
  },
  {
    source: 'Jesse Owens',
    text:
      'Find the good. It’s all around you. Find it, showcase it and you’ll start believing in it.'
  },
  {
    source: 'Audre Lorde',
    text:
      'If I didn’t define myself for myself, I would be crunched into other people’s fantasies for me and eaten alive.'
  },
  {
    source: 'Viola Davis',
    text: 'I prayed for twenty years but received no answer until I prayed with my legs.'
  },
  {
    source: 'Frederick Douglass',
    text:
      'Always wake up with a smile knowing that today you are going to have fun accomplishing what others are too afraid to do.'
  },
  {
    source: 'Barack Obama ',
    text:
      'Change will not come if we wait for some other person, or if we wait for some other time. We are the ones we’ve been waiting for. We are the change that we seek.'
  },
  {
    source: 'James Baldwin',
    text:
      'There is never time in the future in which we will work out our salvation. The challenge is in the moment; the time is always now.'
  },
  {
    source: 'Dr. Martin Luther King, Jr.',
    text:
      'If you can’t fly then run, if you can’t run then walk, if you can’t walk then crawl, but whatever you do you have to keep moving forward.'
  },
  {
    source: 'Dr. Mae Jamison',
    text: 'Never be limited by other people’s limited imaginations.'
  },
  {
    source: 'Phylicia Rashad',
    text:
      'There’s always something to suggest that you’ll never be who you wanted to be. Your choice is to take it or keep on moving.'
  },
  {
    source: 'Beyoncé Knowles',
    text: 'Power is not given to you.  You have to take it.'
  },
  {
    source: 'Arthur Ashe',
    text:
      'One important key to success is self-confidence. An important key to self-confidence is preparation.'
  },
  {
    source: 'Frank Sinatra',
    text: 'The best revenge is massive success.'
  },
  {
    source: 'J.K. Rowling',
    text:
      'Always wake up with a smile knowing that today you are going to have fun accomplishing what others are too afraid to do.'
  },
  {
    source: 'Steve Jobs',
    text: 'Your time is limited, so don’t waste it living someone else’s life.'
  },
  {
    source: 'Zig Ziglar',
    text:
      'People often say that motivation doesn’t last. Well, neither does bathing. That’s why we recommend it daily.'
  },
  {
    source: 'Jim Rohn',
    text: 'You are the average of the five people you spend the most time with.'
  },
  {
    source: 'Vince Lombardi',
    text:
      'The difference between a successful person and others is not a lack of strength, not a lack of knowledge, but rather a lack of will.'
  },
  {
    source: 'Bruce Lee',
    text: 'If you love life, don’t waste time, for time is what life is made up of.'
  },
  {
    source: 'Abraham Lincoln',
    text: 'Things may come to those who wait, but only the things left by those who hustle.'
  },
  {
    source: 'John Lennon',
    text: 'Life is what happens while you are busy making other plans.'
  },
  {
    source: 'Angelica Monroy',
    text: 'Embrace your vulnerabilities, accept them, and forgive yourself.'
  },
  {
    source: 'Iris Soto',
    text:
      'Always wake up with a smile knowing that today you are going to have fun accomplishing what others are too afraid to do.'
  },
  {
    source: 'Carlos Santana',
    text:
      'The most valuable possession you can own is an open heart. The most powerful weapon you can be is an instrument of peace.'
  },
  {
    source: 'Cesar Chavez ',
    text:
      'Preservation of one’s own culture does not require contempt or disrespect for other cultures.'
  },
  {
    source: 'Gwendolyn Brooks',
    text:
      'In the face of difficult challenges remember that these are blessings in disguise,  push through them with faith.'
  },
  {
    source: 'Dolly Parton ',
    text: 'The way I see it, if you want the rainbow, you gotta put up with the rain.'
  },
  {
    source: 'Dr. Seuss',
    text: 'Sometimes you will never know the value of a moment until it becomes a memory.'
  },
  {
    source: 'C.S. Lewis',
    text: 'You are never too old to set another goal or dream a new dream.'
  },
  {
    source: 'Helen Keller',
    text: 'Never bend your head. Always hold it high. Look the world straight in the eye.'
  },
  {
    source: 'Theodore Roosevelt',
    text: 'Believe you can and you’re halfway there.'
  },
  {
    source: 'Carol Burnett',
    text: 'When you have a dream, you’ve got to grab it and never let go.'
  },
  {
    source: 'Albert Einstein',
    text: 'Life is like riding a bicycle. To keep your balance, you must keep moving.'
  },
  {
    source: 'Ella Fitzgerald',
    text:
      'Just don’t give up trying to do what you really want to do. Where there is love and inspiration, I don’t think you can go wrong.'
  },
  {
    source: 'Amy Poehler',
    text: 'Limit your "always" and your "nevers."'
  },
  {
    source: 'Maya Angelou',
    text: 'Try to be a rainbow in someone else’s cloud.'
  },
  {
    source: '"Camilla Eyring Kimball',
    text: 'You do not find the happy life. You make it.'
  },
  {
    source: 'E.E. Cummings',
    text: 'The most wasted of days is one without laughter.'
  },
  {
    source: 'George Eliot',
    text: 'It is never too late to be what you might have been.'
  },
  {
    source: 'Hazrat Inayat Khan',
    text: 'Some people look for a beautiful place. Others make a place beautiful.'
  },
  {
    source: 'Lindsey Von',
    text: 'Life changes very quickly, in a very positive way, if you let it.'
  },
  {
    source: 'Malala Yousafzai',
    text: 'Let us make our future now, and let us make our dreams tomorrow’s reality.'
  },
  {
    source: 'Mandy Hale',
    text:
      'You don’t always need a plan. Sometimes you just need to breathe, trust, let go, and see what happens.'
  },
  {
    source: 'Meghan Markle',
    text: 'You are enough just as you are.'
  },
  {
    source: 'Martin Luther King Jr.',
    text: 'If I cannot do great things, I can do small things in a great way.'
  },
  {
    source: 'Nicole Kidman',
    text: 'Life has got all those twists and turns. You’ve got to hold on tight and off you go.'
  },
  {
    source: 'Oprah Winfrey',
    text: 'If you look at what you have in life, you’ll always have more.'
  },
  {
    source: 'Reese Witherspoon',
    text: 'With the right kind of coaching and determination you can accomplish anything.'
  },
  {
    source: 'Roald Dahl',
    text:
      'If you have good thoughts they will shine out of your face like sunbeams and you will always look lovely.'
  },
  {
    source: 'Robin Williams',
    text: 'No matter what people tell you, words and ideas can change the world.'
  },
  {
    source: 'Rosa Parks',
    text: 'Each person must live their life as a model for others.'
  },
  {
    source: 'Serena Williams',
    text: 'A champion is defined not by their wins but by how they can recover when they fall.'
  },
  {
    source: 'Sheryl Sandberg',
    text: 'Motivation comes from working on things we care about.'
  },
  {
    source: 'Walt Whitman',
    text: 'Keep your face always toward the sunshine, and shadows will fall behind you.'
  },
  {
    source: 'John Bunyan',
    text:
      'You have not lived today until you have done something for someone who can never repay you.'
  },
  {
    source: 'Walt Whitman',
    text: 'Every moment of light and dark is a miracle.'
  },
  {
    source: 'Will Rogers',
    text: 'Even if you’re on the right track, you’ll get run over if you just sit there.'
  },
  {
    source: 'Mark Zuckerberg',
    text:
      'The biggest risk is not taking any risk… In a world that changing really quickly, the only strategy that is guaranteed to fail is not taking risks.'
  },
  {
    source: 'Napolean Hill',
    text: 'What the mind can conceive, it can achieve.'
  },
  {
    source: 'Ted Murphy',
    text: 'If it isn’t a little scary it probably isn’t worth your time.'
  },
  {
    source: 'Sydney Harris',
    text:
      'When I hear somebody sigh, ‘Life is hard,’ I am always tempted to ask, ‘Compared to what?'
  },
  {
    source: 'Arthur Schopenhauer',
    text:
      'Every truth passes through three stages before it is recognized. In the first, it is ridiculed. In the second, it is opposed. In the third, it is regarded as self evident.'
  },
  {
    source: 'John F. Kennedy',
    text: 'If not us, who? If not now, when?'
  },
  {
    source: 'Jack Canfield ',
    text: 'Don’t worry about failures, worry about the chances you miss when you don’t even try.'
  },
  {
    source: 'Sir Claus Moser',
    text: 'Education costs money. But then so does ignorance.'
  },
  {
    source: 'John Wooden',
    text: 'Do not let what you cannot do interfere with what you can do.'
  },
  {
    source: 'Babe Ruth',
    text: 'Every strike brings me closer to the next home run.'
  },
  {
    source: 'Dr. Martin Luther King Jr.',
    text: 'Our lives begin to end the day we become silent about things that matter.'
  },
  {
    source: 'Maya Angelou',
    text:
      'Prejudice is a burden that confuses the past, threatens the future, and renders the present inaccessible.'
  },
  {
    source: 'Rosa Parks',
    text:
      'To bring about change, you must not be afraid to take the first step. We will fail when we fail to try.'
  },
  {
    source: 'James Baldwin',
    text:
      'Not everything that is faced can be changed, but nothing can be changed until it is faced.'
  },
  {
    source: 'Dr. Martin Luther King Jr.',
    text:
      'Darkness cannot drive out darkness; only light can do that. Hate cannot drive out hate; only love can do that.'
  },
  {
    source: 'Malcolm X',
    text: 'A man who stands for nothing will fall for anything.'
  },
  {
    source: 'Dr. Cornel West',
    text: 'Justice is what love looks like in public.'
  },
  {
    source: 'Malcolm X',
    text:
      'You can’t separate peace from freedom because no one can be at peace unless he has his freedom.'
  },
  {
    source: 'Andrew Hendrixson',
    text: 'Anyone who has ever made anything of importance was disciplined.'
  },
  {
    source: 'Coco Chanel',
    text: 'Don’t spend time beating on a wall, hoping to transform it into a door.'
  },
  {
    source: 'Albert Einstein',
    text: 'Creativity is intelligence having fun.'
  },
  {
    source: 'Grace Coddington',
    text: 'Always keep your eyes open. Keep watching. Because whatever you see can inspire you.'
  },
  {
    source: 'Henry David Thoreau',
    text:
      'What you get by achieving your goals is not as important as what you become by achieving your goals.'
  },
  {
    source: 'Seth Godin',
    text:
      'Instead of wondering when your next vacation is, maybe you should set up a life you don’t need to escape from.'
  },
  {
    source: 'John Maxwell',
    text: 'Sometimes you win, sometimes you learn.'
  },
  {
    source: 'Audre Lorde',
    text:
      'Caring for myself is not self-indulgence, it is self-preservation, and that is an act of political warfare.'
  },
  {
    source: 'Assata Shakur',
    text: 'Dreams and reality are opposites. Action synthesizes them.'
  },
  {
    source: 'Wangari Maathai',
    text: 'There are opportunities even in the most difficult moments.'
  },
  {
    source: 'Rev. Peter Marshall',
    text:
      'May we think of freedom, not as the right to do as we please, but as the opportunity to do what is right.'
  },
  {
    source: 'Martha Grimes',
    text: 'We don’t know who we are until we see what we can do.'
  },
  {
    source: 'Vidal Sassoon ',
    text: 'Take good advice, make sure it is good advice, then do it your way.'
  },
  {
    source: 'Adelaide Anne Procter',
    text:
      'Never tell people how to do things. Tell them what to do, and they will surprise you with their ingenuity.'
  },
  {
    source: 'George Patton',
    text: 'If not us, who? If not now, when?'
  },
  {
    source: 'Robert Frost ',
    text: 'Most of the change we think we see in life is due to truths being in and out of favor.'
  },
  {
    source: 'Bob Black',
    text:
      'You are what you do. If you do boring, stupid, monotonous work, chances are you’ll end up boring, stupid, and monotonous.'
  },
  {
    source: 'Georg Wilhelm Friedrich Hegel',
    text: 'Nothing great in the world has been accomplished without passion.'
  },
  {
    source: 'Robert Louis Stevenson',
    text: 'Don’t judge each day by the harvest you reap but by the seeds that you plant.'
  },
  {
    source: 'Friedrich Nietzsche',
    text:
      'There exists in the world a single path along which no one can go except you: whither does it lead? Do not ask, go along it.'
  },
  {
    source: 'Pablo Picasso ',
    text: 'Art is a lie that makes us realize truth.'
  },
  {
    source: 'Henry David Thoreau',
    text:
      'If one advances confidently in the direction of his dreams, and endeavors to live the life which he has imagined, he will meet with a success unexpected in common hours.'
  },
  {
    source: 'Bob Dylan',
    text:
      'It’s not to anybody’s best interest to think about how they will be perceived tomorrow. It hurts you in the long run.'
  },
  {
    source: 'Stephen Vincent Benet',
    text:
      'Life is not lost by dying! Life is lost minute by minute, day by dragging day, in all the thousand, small, uncaring ways.'
  },
  {
    source: 'Mary Shelley',
    text: 'Nothing is so painful to the human mind as a great and sudden change.'
  },
  {
    source: 'E.M. Forster',
    text: 'Either life entails courage, or it ceases to be life.'
  },
  {
    source: 'Ellen DeGeneres',
    text:
      'I learned compassion from being discriminated against. Everything bad that’s ever happened to me has taught me compassion.'
  },
  {
    source: 'James Cameron',
    text:
      'Failure has to be an option. ... No important endeavor that required innovation was done without risk.'
  },
  {
    source: 'Mandy Hale',
    text: 'Be bold enough to live life on your terms, and never apologize for it.'
  },
  {
    source: 'Debbi Fields',
    text: 'The biggest failure in life is never trying.'
  },
  {
    source: 'Elizabeth Barrett Browning',
    text: 'Measure not the work until the day’s out and the labor done.'
  },
  {
    source: 'Ingvar Kamprad',
    text:
      'Making mistakes is the privilege of the active -- of those who can correct their mistakes and put them right.'
  },
  {
    source: 'Leo Tolsto',
    ttext: 'Everybody thinks of changing humanity, and nobody thinks of changing himself.'
  },
  {
    source: 'Aldous Huxley',
    text:
      'There’s only one corner of the universe you can be certain of improving, and that’s your own self.'
  },
  {
    source: 'Theodore Thornton Munger',
    text: 'Nothing is more common than unsuccessful men of talent.'
  },
  {
    source: 'Steve Jobs',
    text:
      'I’m convinced that about half of what separates the successful entrepreneurs from the nonsuccessful ones is pure perseverance. It is so hard.'
  },
  {
    source: 'Dwight D. Eisenhower',
    text: 'Plans are worthless, but planning is everything.'
  },
  {
    source: 'Booker T. Washington',
    text:
      'There are two ways of exerting one’s strength: One is pushing down, the other is pulling up.'
  },
  {
    source: 'James Thurber',
    text: 'May your choices reflect your hopes, not your fears.'
  },
  {
    source: 'Nelson Mandela',
    text: 'May your choices reflect your hopes, not your fears.'
  },
  {
    source: 'Steve Jobs',
    text: 'Things don’t have to change the world to be important.'
  },
  {
    source: 'Albert Einstein',
    text: 'Peace cannot be kept by force; it can only be achieved by understanding.'
  },
  {
    source: 'Frederick Douglass',
    text: 'The soul that is within me no man can degrade.'
  },
  {
    source: 'Peter Drucker',
    text: 'The most important thing in communication is hearing what isn’t said.'
  },
  {
    source: 'Molière',
    text: 'It is a fine seasoning for joy to think of those we love.'
  },
  {
    source: 'William Feather',
    text: 'No man is a failure who is enjoying life.'
  },
  {
    source: 'Pablo Picasso',
    text: 'Learn the rules like a pro, so you can break them like an artist.'
  },
  {
    source: 'WUrsula Le Guin',
    text:
      'It is good to have an end to journey towards, but it is the journey that matters, in the end.'
  },
  {
    source: 'John F. Kennedy',
    text: 'Conformity is the jailer of freedom and the enemy of growth.'
  },
  {
    source: 'Robert Anthony',
    text: 'Some people drink from the fountain of knowledge. Others just gargle.'
  },
  {
    source: 'Ralph Waldo Emerson',
    text: 'Every artist was first an amateur.'
  },
  {
    source: 'Samuel Butler',
    text: 'All animals, except man, know that the principal business of life is to enjoy it.'
  },
  {
    source: 'Bruce Lee',
    text: 'Absorb what is useful. Discard what is not. Add what is uniquely your own.'
  },
  {
    source: 'Earl Nightingale',
    text: 'We become what we think about.'
  },
  {
    source: 'Theodore Vail',
    text: 'Real difficulties can be overcome; it is only the imaginary ones that are unconquerable.'
  },
  {
    source: 'Washington Irving',
    text: 'Little minds are tamed and subdued by misfortune, but great minds rise above them.'
  },
  {
    source: 'Arnold Bennett',
    text:
      'Any change, even a change for the better, is always accompanied by drawbacks and discomforts.'
  },
  {
    source: 'Dhirubhai Ambani',
    text: 'If you don’t build your dream, someone else will hire you to help them build theirs.'
  },
  {
    source: 'Mario Andretti',
    text: 'If things seem under control, you are just not going fast enough.'
  },
  {
    source: 'Oprah Winfrey',
    text:
      'Be thankful for what you have; you’ll end up having more. If you concentrate on what you don’t have, you will never, ever have enough.'
  },
  {
    source: 'Helen Keller',
    text:
      'Avoiding danger is no safer in the long run than outright exposure. The fearful are caught as often as the bold.'
  },
  {
    source: 'Thomas Paine',
    text: 'The harder the conflict, the more glorious the triumph.'
  },
  {
    source: 'Frank Tyger',
    text: 'There is no greater loan than a sympathetic ear.'
  },
  {
    source: 'Phyllis Theroux',
    text: 'Mistakes are the usual bridge between inexperience and wisdom.'
  },
  {
    source: 'Gaylord Nelson',
    text:
      'The ultimate test of man’s conscience may be his willingness to sacrifice something today for future generations whose words of thanks will not be heard.'
  },
  {
    source: 'Sarah Grand',
    text:
      'Our opinion of people depends less upon what we see in them than upon what they make us see in ourselves.'
  },
  {
    source: 'George Santayana',
    text: 'There is no cure for birth and death save to enjoy the interval.'
  },
  {
    source: 'Margaret Chase Smith',
    text: 'When people keep telling you that you can’t do a thing, you kind of like to try it.'
  },
  {
    source: 'André Gide',
    text: 'Believe those who are seeking the truth; doubt those who find it.'
  },
  {
    source: 'Frank Yerby',
    text: 'Maturity is reached the day we don’t need to be lied to about anything.'
  },
  {
    source: 'Charles Dickens',
    text: 'Maturity is reached the day we don’t need to be lied to about anything.'
  },
  {
    source: 'Merry Browne',
    ttext:
      'Expect people to be better than they are; it helps them to become better. But don’t be disappointed when they are not; it helps them to keep trying.'
  },
  {
    source: 'Doug Larson',
    text: 'Wisdom is the quality that keeps you from getting into situations where you need it.'
  },
  {
    source: 'Laozi',
    text: 'To attain knowledge, add things every day. To attain wisdom, subtract things every day.'
  }
]
